import { Colors, FontFamily } from '@/utils/models/globalTypes';
import style from './linkUrl.module.scss';
import Link from 'next/link';
import { CSSProperties, RefObject } from 'react';

interface Props {
    url?: string;
    ref?: RefObject<HTMLAnchorElement>;
    text?: string;
    children?: React.ReactNode;
    reactRouter?: boolean;
    classes?: string[];
    backgroundColor?: Colors;
    fontFamily?: FontFamily;
    outline?: boolean;
    noLink?: boolean;
    dataTest?: string;
    hexColor?: string;
    onClick?: (e?: any) => void;
    title?: string;
    targetBlanc?: boolean;
    css?: CSSProperties;
}

export const LinkUrl = ({
    url,
    ref,
    text,
    children,
    reactRouter = true,
    classes = [],
    backgroundColor,
    fontFamily = FontFamily.MUNDIAL_LIGHT,
    outline = false,
    noLink = false,
    dataTest,
    hexColor,
    onClick,
    title,
    targetBlanc = false,
    css,
}: Props) => {

    return (
        <>
            {
                reactRouter && !noLink
                    ?
                    <Link
                        href={url ?? '/'}
                        ref={ref}
                        className={`
                          ${style.link}
                          ${style[fontFamily]}
                          ${backgroundColor ? style[backgroundColor] : ''}
                          ${outline ? style.outline : ''}
                          ${classes.join(' ')}
                      `}
                        onClick={onClick}
                        data-test={dataTest}
                        style={{...css, color: hexColor }}
                        title={title}
                        target={targetBlanc ? '_blank' : undefined}
                    >
                        {text ? text : children}
                    </Link>
                    :
                    !noLink
                        ?
                        <a
                            href={url ?? '/'}
                            target="_blank"
                            className={`
                                ${style.link}
                                ${style[fontFamily]}
                                ${backgroundColor ? style[backgroundColor] : ''}
                                ${outline ? style.outline : ''}
                                ${classes.join(' ')}
                            `}
                            rel="noreferrer"
                            onClick={onClick}
                            data-test={dataTest}
                            style={{ ...css, color: hexColor }}
                            title={title}
                        >
                            {text ? text : children}
                        </a>
                        :
                        <div
                            className={`
                                ${style.link}
                                ${style[fontFamily]}
                                ${backgroundColor ? style[backgroundColor] : ''}
                                ${outline ? style.outline : ''}
                                ${classes.join(' ')}
                            `}
                            rel="noreferrer"
                            onClick={onClick}
                            data-test={dataTest}
                            style={{ ...css, color: hexColor }}
                            title={title}
                        >
                            {text ? text : children}
                        </div>
            }
        </>
    )
}

export default LinkUrl;